export const STORE_KEY = '@@newsletter'
export const NEWSLETTER_INITIATED = `${STORE_KEY}/NEWSLETTER_INITIATED`
export const NEWSLETTER_SIGNUP_REQUEST = `${STORE_KEY}/NEWSLETTER_SIGNUP_REQUEST`
export const NEWSLETTER_SIGNUP_SUCCESS = `${STORE_KEY}/NEWSLETTER_SIGNUP_SUCCESS`
export const NEWSLETTER_SIGNUP_FAILURE = `${STORE_KEY}/NEWSLETTER_SIGNUP_FAILURE`
